export default {
    phone: 600,
    tabletPortrait: 900,
    tabletLandscape: 1400,
    desktop: 1800
}


// WEBPACK FOOTER //
// ./assets/js/helpers/breakpoints.js